import { getCostCenterLinkedCards } from '@api/cost-centers/cost-centers.service';
import { useQuery } from '@tanstack/react-query';

export const useCreditCards = ({ accountId }: { accountId?: string }) => {
  const {
    data: cards,
    isLoading: cardsLoading,
    refetch: refetchCards,
  } = useQuery({
    queryKey: ['credit-cards', accountId],
    queryFn: () => getCostCenterLinkedCards(accountId!),
    enabled: !!accountId,
    initialData: [],
  });

  return {
    cardsLoading,
    refetchCards,
    cards,
  };
};
